import Box from '@mui/material/Box/Box'
import Link from '@mui/material/Link/Link'
import Paper from '@mui/material/Paper/Paper'
import useTheme from '@mui/material/styles/useTheme'
import Typography from '@mui/material/Typography/Typography'
import { useMemo } from 'react'

import { useLocationContext } from '@providers/location/location_provider'
import { i18WithParams as t, i18WithComponent as tc } from '@shared/locale'
import { WaitlistIcon } from 'components-ui/src/asset/waitlist_icon'
import { generatePhoneFromString } from 'components-ui/src/shared/common'

const Underline = () => {
  return (
    <Typography component="span" variant="body1" sx={{ textDecoration: 'underline' }}>
      {t('waitlistConfirmation.note.not')}
    </Typography>
  )
}

const Phone = () => {
  const { location } = useLocationContext()
  const phoneData = useMemo(() => location?.communications?.find((c) => c.type === 'PHONE'), [location])
  if (!phoneData) return null

  return (
    <Link href={`tel:${phoneData.value}`} sx={{ lineHeight: '1.4', color: 'primary.main' }}>
      {generatePhoneFromString(phoneData.value)}
    </Link>
  )
}

export const WaitlistConfirmation = () => {
  const theme = useTheme()

  return (
    <Box sx={{ maxWidth: 700, margin: '0 auto', px: { xs: 2, sm: 3 }, py: 3 }}>
      <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, borderRadius: 1, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <WaitlistIcon color="action" sx={{ fontSize: '3.5rem' }} />
        </Box>
        <Typography variant="h1">{t('waitlistConfirmation.title')}</Typography>

        <Typography
          variant="h5"
          sx={{ mt: 2, backgroundColor: theme.palette.error.shade8, px: 2, py: 1, display: 'inline-block' }}
        >
          {t('waitlistConfirmation.confirmation')}
        </Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          {tc('waitlistConfirmation.note', { not: <Underline /> })}
        </Typography>
        <Typography variant="body1" sx={{ mt: 4 }}>
          {t('waitlistConfirmation.reservation')}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4 }}>
          {tc('waitlistConfirmation.callus', { phoneNumber: <Phone /> })}
        </Typography>
      </Paper>
    </Box>
  )
}
